import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Meta, Title } from '@angular/platform-browser';

import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FetchArrayDataService } from '../../services/fetch-array-data.service';
import { FooterComponent } from '../../Common/footer/footer.component';
import { HeaderComponent } from '../../Common/header/header.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SeoService } from '../../services/seo.service';

@Component({
    selector: 'app-blogs',
    templateUrl: './blogs.component.html',
    styleUrls: ['./blogs.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterLink, ReactiveFormsModule, HttpClientModule, MatSnackBarModule, HeaderComponent, FooterComponent]
})
export class BlogsComponent implements OnInit {

  popularPosts: any;
  blogCategories: any[] = []; // Initialize as an empty array to store blog categories
  AllArticleDetails: any[] = []; // Initialize as an empty array
  latestFive: any[] = []; // Initialize as an empty array
  storageUrl = environment.storageUrl;
  baseUrl = environment.baseUrl;
  domainUrl = environment.domainUrl;
  constructor(
     private snackBar: MatSnackBar,
     private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object,
     private http: HttpClient) { }

  ngOnInit(): void {
    // Set default metadata immediately
    this.seoService.updateMetaTags({
      title: 'Blogs - Rohit Parihar',
      description: 'Explore financial planning insights, investment strategies, and expert advice from Rohit Parihar.',
      image: `${this.domainUrl}/assets/budget-planning-people-analyzing-personal-corporate-budget-finance-accounting-calculation-financial-21897174_benchback_5.jpg`,
      url: `${this.domainUrl}/blog`,
      type: 'website',
      keywords: 'financial planning, investment advice, financial management, Rohit Parihar, financial services, financial咨询, financial规划, financial建议, financial服务, financial管理'
    });

    this.FetchAllArtical();
    this.fetchlatestfive();
    this.FetchBlogCategories();

  }

  // Fetch all articles or articles by category
  FetchAllArtical(ID?: any): void {
    const obj = {
      account_id: 1, // Account ID
      category_id: ID ?? null
    };

    this.http.post(`${this.baseUrl}/latest_articles`, obj).subscribe({
      next: (res: any) => {
        this.AllArticleDetails = res.data;

        // Update metadata with dynamic content
        this.seoService.updateMetaTags({
          title: 'Blogs - Rohit Parihar',
          description: 'Explore financial planning insights, investment strategies, and expert advice from Rohit Parihar.',
          image: `${this.domainUrl}/assets/budget-planning-people-analyzing-personal-corporate-budget-finance-accounting-calculation-financial-21897174_benchback_5.jpg`,
          url: `${this.domainUrl}/blog`,
          type: 'website',
          keywords: 'financial planning, investment advice, financial management, Rohit Parihar, financial services, financial咨询, financial规划, financial建议, financial服务, financial管理'
        });

      },
      error: (err: any) => {
        console.log(err);
        this.snackBar.open('Unable to fetch articles.', 'Close', { duration: 3000 });
      }
    });
  }

  // Fetch blog categories
  FetchBlogCategories(): void {
    this.http.get(`${this.baseUrl}/fetch_categories`).subscribe({
      next: (res: any) => {
        this.blogCategories = res.data;
      },
      error: (err: any) => {
        console.log(err);
        this.snackBar.open('Unable to fetch blog categories.', 'Close', { duration: 3000 });
      }
    });
  }

  // Fetch the latest five articles
  fetchlatestfive(): void {
    this.http.post(`${this.baseUrl}/latest_articles_five`, { account_id: 1 }).subscribe({
      next: (res: any) => {
        this.latestFive = res.data;
      },
      error: (err: any) => {
        console.log(err);
        this.snackBar.open('Unable to fetch the latest blogs.', 'Close', { duration: 3000 });
      }
    });
  }


}
